import { useContext } from 'react';
import { DataEstimateContext } from '..';

export const useDataEstimateContext = () => {
  const dataEstimateContext = useContext(DataEstimateContext);
  if (!dataEstimateContext) throw Error('You need use it with a DataEstimateProvider');
  return dataEstimateContext;
};
